import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { Card, CardContent, CardMedia, Typography, Grid, Box, Button } from '@mui/material';
import { Star, Person, FiberManualRecord } from '@mui/icons-material';

const API_URL = process.env.REACT_APP_API_URL;

const RequestUserCard = ({ user }) => {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  return (
    <div>
      <Link to={`/request-user-tab-details/${user.id}`} style={{ textDecoration: "none" }}>
        <Card
          sx={{
            maxWidth: 400,
            margin: 2,
            borderRadius: '15px',
            boxShadow: 5,
            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
            '&:hover': {
              transform: 'scale(1.05)',
              boxShadow: 8,
            },
            backgroundColor: '#000000',
            color: '#fff',
          }}
        >
          {/* User Image */}
          {user.image ? (
            <CardMedia
              component="img"
              height="200"
              image={`${API_URL}${user.image}`}
              alt={`${user.name} profile`}
              sx={{
                objectFit: 'cover',
                borderRadius: '15px 15px 0 0',
                borderBottom: '4px solid #2196F3',
              }}
            />
          ) : (
            <Box
              sx={{
                height: 200,
                backgroundColor: '#1111',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '15px 15px 0 0',
              }}
            >
              <Person sx={{ fontSize: 60, color: '#bbb' }} />
            </Box>
          )}
          {/* Card Content */}
          <CardContent sx={{ textAlign: 'center' }}>
            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
              {user.name} {user.surname}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {user.about ? user.about : "No bio available."}
            </Typography>

            {/* Online Status */}
            <Typography
              variant="body2"
              color={user.online ? 'green' : 'red'}
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}
            >
              <FiberManualRecord sx={{ fontSize: 14, marginRight: 1 }} />
              {user.online ? 'Online' : 'Offline'}
            </Typography>

            {/* Ratings and Experience */}
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={6}>
                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
                  <Star sx={{ fontSize: 18, marginRight: 0.5 }} />
                  {user.rating ? user.rating : 'No rating'}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="text.primary">
                  {user.Experience ? `${user.Experience} years` : 'No experience'}
                </Typography>
              </Grid>
            </Grid>

            {/* Request Button */}
            <Box sx={{ mt: 2 }}>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  fontSize: '1.1rem',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  boxShadow: 4,
                  backgroundImage: 'linear-gradient(45deg, #2196F3, #1976D2)',
                  '&:hover': {
                    backgroundImage: 'linear-gradient(45deg, #1976D2, #2196F3)',
                    boxShadow: 8,
                    transform: 'scale(1.05)',
                  },
                  width: '100%',
                }}
              >
                Request Now
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Link>
    </div>
  );
};

export default RequestUserCard;
